import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/format";

export default function PortalProfile() {
  const { setUser } = useAuth();
  const [form, setForm] = useState({ first_name: "", last_name: "", phone: "", email: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/students/me").then((r) => {
      const s = r.data;
      setForm({ first_name: s.first_name || "", last_name: s.last_name || "", phone: s.phone || "", email: s.email || "" });
    }).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/students/me", { first_name: form.first_name, last_name: form.last_name, phone: form.phone });
      const me = await api.get("/auth/me");
      setUser(me.data);
      toast.success("Profile updated.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="max-w-lg space-y-8" data-testid="portal-profile">
      <div>
        <p className="overline mb-2">Your details</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-ink tracking-tight">Profile</h1>
      </div>

      <form onSubmit={save} className="paper-card p-8 space-y-5">
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <label className="field-label">First name</label>
            <input className="field-input" value={form.first_name} onChange={set("first_name")} required data-testid="profile-first" />
          </div>
          <div>
            <label className="field-label">Last name</label>
            <input className="field-input" value={form.last_name} onChange={set("last_name")} data-testid="profile-last" />
          </div>
        </div>
        <div>
          <label className="field-label">Email</label>
          <input className="field-input bg-hairline/30 cursor-not-allowed" value={form.email} disabled data-testid="profile-email" />
        </div>
        <div>
          <label className="field-label">Phone</label>
          <input className="field-input" value={form.phone} onChange={set("phone")} placeholder="(323) 555-0100" data-testid="profile-phone" />
        </div>
        <button type="submit" disabled={busy} className="btn-brass" data-testid="profile-save">
          {busy ? "Saving…" : "Save changes"}
        </button>
      </form>
    </div>
  );
}
